




import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import NewContainer from '@/containers/cv-section-gallery/new.vue';

import * as CvSectionGalleryStoreNew from '@/store/modules/cvSectionGalleryNew';

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook],
  data() {
    return {
      storeList: [CvSectionGalleryStoreNew],
    };
  },
});
